<mat-card-footer *ngIf="data">
  <div class="grid-container">
    <ng-container
      *ngTemplateOutlet="columnTemplate; context: { key: 'common/created-by', value: data.createdBy }"></ng-container>
    <ng-container
      *ngTemplateOutlet="
        columnTemplate;
        context: { key: 'common/created-at', value: data.createdAtLabel }
      "></ng-container>
    <ng-container
      *ngTemplateOutlet="columnTemplate; context: { key: 'common/modified-by', value: data.modifiedBy }"></ng-container>
    <ng-container
      *ngTemplateOutlet="
        columnTemplate;
        context: { key: 'common/modified-at', value: data.modifiedAtLabel }
      "></ng-container>
  </div>
</mat-card-footer>

<ng-template #columnTemplate let-key="key" let-value="value">
  <div *ngIf="value">
    <label [translate]="key"></label>
    <span>{{ value }}</span>
  </div>
</ng-template>
